import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing4,
} from 'approot/shared/styles/spacing.style';
import {
  fontSize28,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import {
  grey1,
  grey5,
  grey10,
  purple1,
  purple2,
  purple3,
} from 'approot/shared/styles/colours.style';
import {
  borderRadius16,
  borderRadius8,
} from 'approot/shared/styles/borders.style';

export const VocabularyTitle = styled.div`
  background-color: ${purple2};
  border: 1px solid ${purple3};
  border-bottom: none;
  border-radius: ${rem(borderRadius8)} ${rem(borderRadius8)} 0 0;
  color: ${grey10};
  display: inline-block;
  font-size: ${rem(fontSize28)};
  font-weight: ${fontWeightMedium};
  margin-bottom: -${rem(1)};
  padding: ${rem(spacing8)};
`;

export const VocabularyList = styled.ul`
  background-color: ${purple1};
  border: 1px solid ${purple3};
  border-radius: 0 ${rem(borderRadius8)} ${rem(borderRadius8)}
    ${rem(borderRadius8)};
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: ${rem(spacing4)};
`;

export const VocabularyListItem = styled.li`
  display: inline-block;
  margin: ${rem(spacing4)};
`;

export const VocabularyStaticButton = styled.div`
  font-size: ${rem(fontSize28)};
  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius16)};
  padding: ${rem(spacing16)} ${rem(spacing24)};
`;
